// components/MetaFormCard.js
import React from 'react';
import { Formik } from 'formik';
import { Row, Col } from 'react-bootstrap';
import Input from '../../components/input';
import Textarea from '../../components/commonTextArea';
import CommonFormLabel from '../../components/formLabel';
import ValidationFeedback from '../../components/validationFeedback';
import CommonButton from '../../components/commonButton';
// import { TaskEdit02Icon } from '../../assets/icons';
import { metaContentSchema } from '../../schema/validationSchemas';

const MetaFormCard = ({
  title,
  slug,
  seoData,
  editingSection,
  setEditingSection,
  isSubmitting,
  onSubmit,
  onCancel,
}) => {
  const isEditing = editingSection === slug;

  return (
    <div className="card mb-4">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h5 className="my-2">{title}</h5>
        {/* {!isEditing && (
          <CommonButton
            icon={<TaskEdit02Icon width={16} height={16} color="#ffffff" strokeWidth="2" />}
            title="Edit"
            className="btn-primary primary-shadow"
            onClick={() => setEditingSection(slug)}
          />
        )} */}
      </div>
      <div className="card-body">
        {isEditing ? (
          <Formik
            initialValues={{
              meta_title: seoData?.meta_title || '',
              meta_keyword: seoData?.meta_keyword || '',
              meta_description: seoData?.meta_description || '',
              slug: slug,
            }}
            validationSchema={metaContentSchema}
            onSubmit={onSubmit}
          >
            {({ values, handleChange, handleSubmit, touched, errors }) => (
              <form onSubmit={handleSubmit}>
                <Row className="gy-4">
                  <Col md={6}>
                    <CommonFormLabel htmlFor="meta_title" title="Meta Title" />
                    <Input
                      id="meta_title"
                      name="meta_title"
                      value={values.meta_title}
                      onChange={handleChange}
                      className={`shadow-none ${touched.meta_title && errors.meta_title ? 'error' : 'correct'}`}
                    />
                    {touched.meta_title && errors.meta_title && <ValidationFeedback title={errors.meta_title} />}
                  </Col>
                  <Col md={12}>
                    <CommonFormLabel htmlFor="meta_description" title="Meta Description" />
                    <Textarea
                      id="meta_description"
                      name="meta_description"
                      rows={6}
                      value={values.meta_description}
                      onChange={handleChange}
                      className={`shadow-none ${touched.meta_description && errors.meta_description ? 'error' : 'correct'}`}
                    />
                    {touched.meta_description && errors.meta_description && <ValidationFeedback title={errors.meta_description} />}
                  </Col>
                  <Col md={12}>
                    <CommonFormLabel htmlFor="meta_keyword" title="Meta Keywords" />
                    <Textarea
                      id="meta_keyword"
                      name="meta_keyword"
                      rows={6}
                      value={values.meta_keyword}
                      onChange={handleChange}
                      className={`shadow-none ${touched.meta_keyword && errors.meta_keyword ? 'error' : 'correct'}`}
                    />
                    {touched.meta_keyword && errors.meta_keyword && <ValidationFeedback title={errors.meta_keyword} />}
                  </Col>
                  <Col md={12} className="d-flex justify-content-end gap-3 mt-4">
                    <CommonButton className="btn-primary primary-shadow" type="submit" disabled={isSubmitting} title={isSubmitting ? "Updating..." : "Update"} />
                    <CommonButton type="button" title="Cancel" className="btn-muted" onClick={onCancel} disabled={isSubmitting} />
                  </Col>
                </Row>
              </form>
            )}
          </Formik>
        ) : (
          <Row className="gy-4">
            <Col md={6}>
              <CommonFormLabel title="Meta Title" />
              <p>{seoData?.meta_title}</p>
            </Col>
            <Col md={12}>
              <CommonFormLabel title="Meta Description" />
              <p>{seoData?.meta_description}</p>
            </Col>
            <Col md={12}>
              <CommonFormLabel title="Meta Keywords" />
              <p>{seoData?.meta_keyword}</p>
            </Col>
          </Row>
        )}
      </div>
    </div>
  );
};

export default MetaFormCard;
